
<template>
    <footer class="page-footer appLightGrey">
        <div class="container">
            <div class="row txtAppDarkGrey">
                <div class="col s12 m4 social-media center">
                    <a href="https://twitter.com/pldespaigne" target="_blank" rel="noopener" class="txtAppDarkGrey"><i class="fab fa-twitter small"></i></a>
                    <a href="https://www.linkedin.com/in/pldespaigne/" target="_blank" rel="noopener" class="txtAppDarkGrey"><i class="fab fa-linkedin small"></i></a>
                    <a href="https://www.github.com/pldespaigne/" target="_blank" rel="noopener" class="txtAppDarkGrey"><i class="fab fa-github small"></i></a>
                    <a href="mailto:pl.despaigne@gmail.com" target="_blank" rel="noopener" class="txtAppDarkGrey"><i class="fas fa-at small"></i></a>
                </div>
                <div class="col s12 m2 center-on-small">
                    <a href="#" class="brand-logo nav-brand"><img class="responsive-img" src="/static/128.png" alt="logo et nom du site sur deux lignes"></a>
                </div>
                <div class="col s12 m4 center-on-small">
                    <h5>devweb</h5>
                    <p>
                        Pierre-Louis Despaigne<br>
                        pl.despaigne@gmail.com<br>
                        SIREN : (procédure en cours)
                    </p>
                </div>
            </div>
        </div>
        <div class="footer-copyright">
            <div class="container txtAppLightGrey hide-on-small-only">
                © 2018 Pierre-Louis Despaigne
                <a class="txtAppLightGrey right" href="#">
                    site réalisé par
                    <span class="foot-logo"><i class="devweb-icon">&#xe800;</i> devweb</span>
                </a>
            </div>
            <div class="container txtAppLightGrey hide-on-med-and-up center">
                <p>© 2018 Pierre-Louis Despaigne</p>
                <a class="txtAppLightGrey" href="#">
                    site réalisé par
                    <span class="foot-logo"><i class="devweb-icon">&#xe800;</i> devweb</span>
                </a>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'sitefooter'
}
</script>

<style scoped>
.footer-copyright {
    background-color: #1d263b;
}
.foot-logo {
    text-decoration: underline;
}
.devweb-icon {
    margin: 0 5px;
    font-family: "font devweb";
    font-style: normal;
}
i:hover {
    color: #ffffff;
}
@media screen and (min-width: 600px){
    .social-media {
        float: right;
        text-align: right;
    }
}
@media screen and (max-width: 600px){
    .center-on-small {
        text-align: center;
    }
    .social-media {
        padding-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue